import Recommendations from './Recommendations.vue'

export default Recommendations
